import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { profileRoutineApproved } from "store/actions/profileRoutineActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { ProfileRoutineFooterProps } from "models/propTypes/profileRoutinePropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import ProfileRoutineMoreActions from "./footerMoreActions";
import { useProfileRoutineService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ProfileRoutineFooter: React.FC<ProfileRoutineFooterProps> = (props) => {
  const profileRoutineService = useProfileRoutineService();
  const { profileRoutine, markAsDoneHandler } = props;

  const dispatch = useDispatch();

  const onSubmitSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(profileRoutineApproved(profileRoutine.id));
  };

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Done),
          onClick: () => profileRoutineService.onClear(profileRoutine),
          type: StyleEnums.DisplayType.Success,
          onActionSuccess: onSubmitSuccess,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.ProfileRoutine.RoutineMarkedAsDone
          ),
        },
      ]}
      moreActions={
        <ProfileRoutineMoreActions profileRoutine={profileRoutine} markAsDoneHandler={props.markAsDoneHandler} />
      }
      disableSuccessMessages={props.disableSuccessMessages}
    />
  );
};

export default ProfileRoutineFooter;
